<itl-loading-indicator *ngIf="loading"></itl-loading-indicator>
<itl-wizard-page
  *ngIf="!loading"
  [pageTitleTransPath]="isNew ? 'components.swodoc.create' : 'components.swodoc.edit'"
  [sectionTitleTransPath]="currentSection?.title"
  [currentPageId]="currentSectionIndex + 1"
  [subHeader]="templateTitle"
  [allPageCount]="audit.auditNodes.length"
  [pageIsValid]="allowedToSave"
  (doneClicked)="save({asDraft: false})"
  (cancelClicked)="cancel()"
  (loadNextClicked)="nextSection()"
  (loadPreviousClicked)="previousSection()"
  (sectionChangeClicked)="openNavPage()"
  [doneIcon]="doneIcon"
  ><div *ngIf="canSaveAsDraft" save-buttons class="headerButtons">
    <itl-button class="saveButton" (click)="save({asDraft: true})" [disabled]="allowedToSave">
      <ion-icon id="checkIcon" name="alberta-save-as-draft"></ion-icon>
      <span class="save-button-text">{{ 'components.swodoc.saveAsDraft' | translate }}</span>
    </itl-button>
    <itl-button class="saveButton" (click)="save({asDraft: false})" [disabled]="!allowedToSave">
      <ion-icon id="checkIcon" [name]="doneIcon"></ion-icon>
      <span class="save-button-text">{{ 'components.swodoc.save' | translate }}</span>
    </itl-button>
  </div>
  <ng-container>
    <ng-container *ngFor="let node of currentSection?.children | swodocEditNodeFilter; trackBy: nodeTrackByFn">
      <ng-container [ngSwitch]="node.nodeType_Id">
        <swodoc-node-cross-therapy-article
          *ngSwitchCase="'crossTherapyArticleData'"
          [node]="node"
        ></swodoc-node-cross-therapy-article>
        <swodoc-node-cross-therapy-summary
          *ngSwitchCase="'crossTherapySummary'"
          [audit]="audit"
        ></swodoc-node-cross-therapy-summary>
        <swodoc-node-cross-therapy-billing-summary
          *ngSwitchCase="'crossTherapyBillingSummary'"
          [audit]="audit"
        ></swodoc-node-cross-therapy-billing-summary>
        <swodoc-node-text
          *ngSwitchCase="'text'"
          [style.display]="node.hidden ? 'none' : 'block'"
          [node]="node"
          (changed)="nodeUpdate($event)"
          [shouldUpdate]="node.updateNode"
        ></swodoc-node-text>
        <swodoc-node-date
          *ngSwitchCase="'date'"
          [style.display]="node.hidden ? 'none' : 'block'"
          [node]="node"
          (changed)="nodeUpdate($event)"
        ></swodoc-node-date>
        <swodoc-node-checkbox
          *ngSwitchCase="'checkbox'"
          [node]="node"
          (changed)="nodeUpdate($event)"
          [style.display]="node.hidden ? 'none' : 'block'"
        ></swodoc-node-checkbox>
        <swodoc-node-dropdown
          *ngSwitchCase="'dropdown'"
          [node]="node"
          (changed)="nodeUpdate($event)"
          [style.display]="node.hidden ? 'none' : 'block'"
        ></swodoc-node-dropdown>
        <swodoc-node-question
          *ngSwitchCase="'question'"
          [node]="node"
          (changed)="nodeUpdate($event)"
          [style.display]="node.hidden ? 'none' : 'block'"
        ></swodoc-node-question>
        <swodoc-node-textarea
          *ngSwitchCase="'textarea'"
          [node]="node"
          (changed)="nodeUpdate($event)"
          [style.display]="node.hidden ? 'none' : 'block'"
        ></swodoc-node-textarea>
        <swodoc-node-signature
          *ngSwitchCase="'signature'"
          #signatureNode
          [node]="node"
          [documentEditService]="documentEditService"
          (changed)="nodeUpdate($event)"
          (changed)="signatureChanged($event)"
          [style.display]="node.hidden ? 'none' : 'block'"
        ></swodoc-node-signature>
        <swodoc-node-barcode
          *ngSwitchCase="'barcode'"
          [node]="node"
          (changed)="nodeUpdate($event)"
          [style.display]="node.hidden ? 'none' : 'block'"
        ></swodoc-node-barcode>
        <swodoc-node-contact
          *ngSwitchCase="'contact'"
          [node]="node"
          (changed)="nodeUpdate($event)"
          [style.display]="node.hidden ? 'none' : 'block'"
        ></swodoc-node-contact>
        <swodoc-node-image
          *ngSwitchCase="'image'"
          [node]="node"
          [documentEditService]="documentEditService"
          (changed)="nodeUpdate($event)"
          [style.display]="node.hidden ? 'none' : 'block'"
        ></swodoc-node-image>
        <swodoc-node-number
          *ngSwitchCase="'number'"
          [node]="node"
          (changed)="nodeUpdate($event)"
          [style.display]="node.hidden ? 'none' : 'block'"
        ></swodoc-node-number>
        <swodoc-node-picture
          [documentEditService]="documentEditService"
          *ngSwitchCase="'picture'"
          [node]="node"
          (changed)="nodeUpdate($event)"
          [style.display]="node.hidden ? 'none' : 'block'"
        ></swodoc-node-picture>
        <swodoc-node-multiplechoice
          *ngSwitchCase="'multiplechoice'"
          [node]="node"
          (changed)="nodeUpdate($event)"
          [style.display]="node.hidden ? 'none' : 'block'"
        ></swodoc-node-multiplechoice>
        <swodoc-node-information
          *ngSwitchCase="'information'"
          [node]="node"
          [style.display]="node.hidden ? 'none' : 'block'"
        ></swodoc-node-information>
        <swodoc-node-signature-signotec
          *ngSwitchCase="'signotec_signature'"
          #signatureNodeSignotec
          [node]="node"
          [documentEditService]="documentEditService"
          (changed)="nodeUpdate($event)"
          (changed)="signatureChanged($event)"
          [style.display]="node.hidden ? 'none' : 'block'"
        >
        </swodoc-node-signature-signotec>
        <swodoc-node-formula
          *ngSwitchCase="'formula'"
          [node]="node"
          [auditNodes]="audit.auditNodes"
          [changer]="formulaInputChanged$"
          (changed)="formulaValueChanged($event)"
          [withEval]="evaluateWithEval"
          [style.display]="node.hidden ? 'none' : 'block'"
        ></swodoc-node-formula>
        <swodoc-node-header *ngSwitchCase="'header'" [style.display]="node.hidden ? 'none' : 'block'" [node]="node">
        </swodoc-node-header>
        <swodoc-node-article-data
          *ngSwitchCase="'articleData'"
          [style.display]="node.hidden ? 'none' : 'block'"
          [node]="node"
        >
        </swodoc-node-article-data>
        <swodoc-node-article-data-single-order
          *ngSwitchCase="'singleOrderArticleData'"
          [style.display]="node.hidden ? 'none' : 'block'"
          [node]="node"
        >
        </swodoc-node-article-data-single-order>

        <swodoc-node-add-article-element
          [style.display]="node.hidden ? 'none' : 'block'"
          [node]="node"
          *ngSwitchCase="'addArticleElement'"
        >
        </swodoc-node-add-article-element>

        <swodoc-node-prescription-data
          *ngSwitchCase="'prescriptionData'"
          [style.display]="node.hidden ? 'none' : 'block'"
          [node]="node"
        >
        </swodoc-node-prescription-data>
        <swodoc-node-medical-order-data
          *ngSwitchCase="'medicalOrderData'"
          [style.display]="node.hidden ? 'none' : 'block'"
          [node]="node"
        >
        </swodoc-node-medical-order-data>
        <swodoc-node-wound-measure
          *ngSwitchCase="'woundmeasure'"
          [node]="node"
          [auditNodes]="audit.auditNodes"
          [documentEditService]="documentEditService"
          (changed)="detectChanges($event)"
          [style.display]="node.hidden ? 'none' : 'block'"
        ></swodoc-node-wound-measure>
        <swodoc-node-document-scan-ios
          *ngSwitchCase="'document_scan_ios'"
          [documentEditService]="documentEditService"
          [node]="node"
          (changed)="nodeUpdate($event)"
          [style.display]="node.hidden ? 'none' : 'block'"
        ></swodoc-node-document-scan-ios>
        <swodoc-node-gs1-barcode
          *ngSwitchCase="'gs1BarcodeScanner'"
          [node]="node"
          (changed)="nodeUpdate($event)"
          [style.display]="node.hidden ? 'none' : 'block'"
        ></swodoc-node-gs1-barcode>
      </ng-container>
    </ng-container>
  </ng-container>

  <itl-wizard-page-footer>
    <itl-button
      class="previewButton"
      *ngIf="(audit.entityType === 'prescription' && prescriptionNode) || (audit.entityType === 'medicalOrder' && medicalOrderNode)"
      [disabled]="loading"
      (click)="preview()"
      >{{'prescription.create.preview' | translate}}</itl-button
    >
  </itl-wizard-page-footer>
</itl-wizard-page>
